angular.module('pipToasts', ['ngMaterial', 'pipControls.Translate'])

import './ToastService';
import './Toast';

export * from './IToastService';